
import ReactPaginate from 'react-paginate';
import { withRouter } from 'react-router-dom';
import PrevIcon from '../../../assets/image/prev-icon.svg';
import NextIcon from '../../../assets/image/next-icon.svg';
import './Pagination.scss';

const Pagination = ({ 
    pageCount, 
    forcePage, 
    onPageChange, 
    history, 
    location, 
    queryParam = 'page' 
}) => {
    const handlePageChange = (data) => {
        const params = new URLSearchParams(location.search);
        params.set(queryParam, data.selected + 1);
        history.push({ search: params.toString() });

        if (onPageChange) {
            onPageChange(data);
        }

        window.scrollTo(0, 0);
    };

    const params = new URLSearchParams(location.search);
    const currentPage = parseInt(params.get(queryParam)) || 1;

    return (
        <div className="pagination-container">
            <ReactPaginate
                forcePage={forcePage !== undefined ? forcePage : currentPage - 1}
                onPageChange={handlePageChange}
                pageCount={pageCount}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                previousLabel={<img src={PrevIcon} alt="prev icon" />}
                nextLabel={<img src={NextIcon} alt="next icon" />}
                containerClassName="pagination-list"
                pageClassName="pagination-item"
                pageLinkClassName="pagination-link"
                activeLinkClassName="pagination-link-active"
                breakClassName="pagination-ellipsis"
            />
        </div>
    );
};

export default withRouter(Pagination);
